// extracted by mini-css-extract-plugin
module.exports = {"icon":"iconStyles__icon--SH6Gt9tzOgQuHl8u9twuP"};